import { omit } from './helpers'
import * as c from './constants';
export const reqqInitState = {}; // FOR JSON API

const startLoading = (state, {
  key
}, loadKey) => {
  const newKey = `LOADING/${loadKey}/${key}`;
  return { ...state,
    [newKey]: true
  };
};

const endLoading = (state, {
  key
}, loadKey) => {
  const newKey = `LOADING/${loadKey}/${key}`;
  return omit(state, newKey);
};

const reducers = {
  [c.GET_SET]: (state, action) => startLoading(state, action, 'get'),
  [c.GOT_SET]: (state, action) => endLoading({ ...state,
    [action.key]: action.data
  }, action, 'get'),
  [c.POST]: (state, action) => startLoading(state, action, 'post'),
  [c.GOT_POST]: (state, action) => endLoading(state, action, 'post'),
  [c.PUT]: (state, action) => startLoading(state, action, 'put'),
  [c.GOT_PUT]: (state, action) => endLoading(state, action, 'put'),
  [c.PATCH]: (state, action) => startLoading(state, action, 'patch'),
  [c.GOT_PATCH]: (state, action) => endLoading(state, action, 'patch'),
  [c.REMOVE]: (state, action) => startLoading(state, action, 'remove'),
  [c.GOT_REMOVE]: (state, action) => endLoading(state, action, 'remove'),
  [c.GOT_ERROR]: (state, action) => endLoading(state, action, action.request_type),
  [c.RESET]: () => reqqInitState,
};

export default reducers;
